import Component from "vue-class-component";
import Vue from "vue";
import { Prop } from "vue-property-decorator";

@Component({
	template: "./action.html",
	components: {}
})
export default class Action extends Vue {
	@Prop() noHeight?: boolean;
}
